/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ReportFileSummary } from './reportFileSummary';
import { ReportMyCheckRef } from './reportMyCheckRef';

export interface SimpleCheck { 
    id?: string;
    checkDate?: Date;
    lph?: SimpleCheck.LphEnum;
    lodType?: SimpleCheck.LodTypeEnum;
    projectName?: string;
    completed?: boolean;
    checkType?: SimpleCheck.CheckTypeEnum;
    checkRuleType?: SimpleCheck.CheckRuleTypeEnum;
    failed?: boolean;
    archived?: boolean;
    archivedAt?: Date;
    reportStatus?: string;
    reportStatusLabel?: string;
    checkName?: string;
    checkTypeLabel?: string;
    workflowInstanceId?: string;
    checkResultId?: string;
    ruleSetCount?: number;
    ruleCount?: number;
    myChecks?: Array<ReportMyCheckRef>;
    fileSummary?: ReportFileSummary;
    checkId?: string;
    checkerName?: string;
    costs?: number;
}
export namespace SimpleCheck {
    export type LphEnum = 'LPH1' | 'LPH2' | 'LPH3' | 'LPH4' | 'LPH5' | 'LPH6' | 'LPH7' | 'LPH8' | 'LPH9';
    export const LphEnum = {
        LPH1: 'LPH1' as LphEnum,
        LPH2: 'LPH2' as LphEnum,
        LPH3: 'LPH3' as LphEnum,
        LPH4: 'LPH4' as LphEnum,
        LPH5: 'LPH5' as LphEnum,
        LPH6: 'LPH6' as LphEnum,
        LPH7: 'LPH7' as LphEnum,
        LPH8: 'LPH8' as LphEnum,
        LPH9: 'LPH9' as LphEnum
    };
    export type LodTypeEnum = 'LOD_100' | 'LOD_200' | 'LOD_300' | 'LOD_400' | 'LOD_500';
    export const LodTypeEnum = {
        _100: 'LOD_100' as LodTypeEnum,
        _200: 'LOD_200' as LodTypeEnum,
        _300: 'LOD_300' as LodTypeEnum,
        _400: 'LOD_400' as LodTypeEnum,
        _500: 'LOD_500' as LodTypeEnum
    };
    export type CheckTypeEnum = 'QUALITY' | 'HOAI' | 'IFC' | 'BASE' | 'SWM' | 'MY_CHECK';
    export const CheckTypeEnum = {
        QUALITY: 'QUALITY' as CheckTypeEnum,
        HOAI: 'HOAI' as CheckTypeEnum,
        IFC: 'IFC' as CheckTypeEnum,
        BASE: 'BASE' as CheckTypeEnum,
        SWM: 'SWM' as CheckTypeEnum,
        MYCHECK: 'MY_CHECK' as CheckTypeEnum
    };
    export type CheckRuleTypeEnum = 'LOI' | 'IDS' | 'HYBRID' | 'AI';
    export const CheckRuleTypeEnum = {
        LOI: 'LOI' as CheckRuleTypeEnum,
        IDS: 'IDS' as CheckRuleTypeEnum,
        HYBRID: 'HYBRID' as CheckRuleTypeEnum,
        AI: 'AI' as CheckRuleTypeEnum
    };
}